require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-mattersburg-schattendorf.json") })
        }
      }, "path---betreuungseinrichtungen-mattersburg-schattendorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-mattersburg-schattendorf!./.cache/json/betreuungseinrichtungen-mattersburg-schattendorf.json
// module id = 937
// module chunks = 231608221292675